
import React, {Component} from 'react'
import { connect } from 'react-redux'
import DockButtonFacade from './Button/DockButtonFacade.js'

const themeUtil = require('../../utils/view/themeUtil.js');
const navigationHandler = require('./navigationHandler');
const navigationButtonsIds = require('./navigationButtonsIds');
const cashFloatUtil = require('../../utils/domain/cashFloatUtil.js');

class DockBarView extends Component 
{
    render()
    {
        let buttonIds = themeUtil.getResolvedDockBar();
        var components = [];

        components.push(<DockButtonFacade onClick={()=>{navigationHandler.handleNavigationButtonOnClick(navigationButtonsIds.notifications)}} button={navigationButtonsIds.notifications} marginLeft="20px"/>)

        for (var index = 0; index < buttonIds.length; index++)
        {
            let button = themeUtil.getResolvedButton(buttonIds[index]);
            let marginLeft = index == 0 ? 'auto' : '10px';
            let marginRight = (index+1 == buttonIds.length) ? "auto": "0px";
            components.push(<DockButtonFacade onClick={()=>{navigationHandler.handleNavigationButtonOnClick(button)}} button={button} marginLeft={marginLeft} marginRight={marginRight}/>)
        }

        components.push(<DockButtonFacade onClick={()=>{navigationHandler.handleNavigationButtonOnClick(navigationButtonsIds.overview)}} button={navigationButtonsIds.overview} marginRight="10px"/>)

        return <div className="d-flex" style={{overflowX:'auto', width:Math.round(window.innerWidth * 0.99)}}>
                    {components}
                </div>
    }
}

const mapStateToProps = state => 
{
    return { 
                cashFloatPayload: cashFloatUtil.getLoadedFloatSession()
           }
}

export default connect(mapStateToProps)(DockBarView)
